import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
} from '@angular/core';
import { IOption } from '@cmps/ng-select';
import { finalize, take, tap } from 'rxjs/operators';

import { Util } from '../../common/common.util';
import {
    TakeUntilDestroy,
    takeUntilDestroy,
} from '../../common/take-until-destroy.decorator';
import { PopUpService } from '../../insight/pop-up.service';
import { SearchUserContainerComponent } from '../../user/search-user.container.component';
import { SearchUserDialog } from '../../user/search-user.dialog';
import { TranslationKeyMap } from '../reports.i18n';
import { ReportsService } from '../reports.service';
import { isValidDateStruct } from '../td-daily-huddle/td-daily-huddle.reports.component';
import {
    TdOffersReportPopulationType,
    TdOffersReportResultParams,
    TdOffersReportSelectionParams,
    TdOffersUser,
} from '../td-offers/td-offers.reports.model';

@Component({
    selector: '[cmpsTdOffersSelectionReport]',
    templateUrl: './td-offers-selection.reports.component.html',
    host: {
        class: 'cmps-reports-td-offers-selection',
    },
})
@TakeUntilDestroy()
export class TdOffersSelectionComponent implements OnDestroy, TakeUntilDestroy {
    @Input() params: TdOffersReportSelectionParams;
    @Input() superGroups: IOption[] = [];
    @Input() reportPopulations: IOption[] = [];
    @Output() generated = new EventEmitter<number>();
    i18n = TranslationKeyMap;
    maxDate = Util.dateToNgbDate(new Date());

    constructor(
        public popUpService: PopUpService,
        private readonly _reportService: ReportsService,
        private readonly _userSearchDialog: SearchUserDialog,
    ) {}

    TdReportPopulationType = TdOffersReportPopulationType;

    get popUpVisible(): boolean {
        return (
            this.popUpService.active &&
            this.popUpService.active.componentRef.instance instanceof
                SearchUserContainerComponent
        );
    }

    ngOnInit(): void {
        //
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngOnDestroy() {
        if (this.popUpVisible) {
            this.popUpService.hide();
        }
        this._userSearchDialog.closeAll();
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    onSelectDate() {
        this.params.invalidStartDate = !isValidDateStruct(
            this.params.startDate,
        );
        this.params.invalidEndDate = !isValidDateStruct(this.params.endDate);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    onSelectPopulationType() {
        this.params.populationID = null;
        console.log(this.params.populationType);
        if (
            this.params.populationType ===
            TdOffersReportPopulationType.Individual
        ) {
            this._reportService
                .retrieveDefaultHierarchyUser()
                .pipe(
                    take(1),
                    tap((user: TdOffersUser) => {
                        this.params.defaultPopulationID = user;
                        this.params.populationID =
                            this.params.defaultPopulationID;
                    }),
                )
                .subscribe();
        }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    onSelectUser(e: MouseEvent) {
        const target = e.target as HTMLElement;
        this._userSearchDialog.openUsingPopUp({
            options: {
                target,
                placement: 'bottom-right',
                containerClass: 'cmps-cdk-z-index-2',
            },
            close: (user) => {
                this.params.invalidUser = false;
                if (user) {
                    this.params.pendingData = true;
                    this._reportService
                        .retrieveDefaultHierarchyUser(user.id)
                        .pipe(
                            tap((u) => {
                                this.params.invalidUser = u.userId !== user.id;
                                this.params.populationID = {
                                    userId: user.id,
                                    userName: `${user.firstName} ${user.lastName}`,
                                };
                                // this.params.defaultPopulationID = {
                                //     userId,
                                //     userName: res.ctx.label as string
                                // };
                            }),
                            finalize(() => {
                                this.params.pendingData = false;
                            }),
                            takeUntilDestroy(this),
                        )
                        .subscribe();
                }
            },
        });
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    selectSuperGroup(event: any) {
        this.params.populationType = TdOffersReportPopulationType.SuperGroup;
        this.params.populationID = {
            userId: Number(event.value),
            userName: String(event.label),
        };
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    get generateReportDisabled() {
        return (
            !this.params.populationType ||
            !this.params.startDate ||
            !this.params.endDate ||
            !this.params.populationID ||
            this.params.invalidUser ||
            this.params.invalidStartDate ||
            this.params.invalidEndDate
        );
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    onGenerateReport() {
        if (this.generateReportDisabled) {
            return;
        }
        this.params.pendingData = true;

        const offersParams: TdOffersReportResultParams = {
            populationType: this.params.populationType,
            populationID: `${this.params.populationID.userId}`,
            startDate: `${this.params.startDate.year}-${this.params.startDate.month}-${this.params.startDate.day}`,
            endDate: `${this.params.endDate.year}-${this.params.endDate.month}-${this.params.endDate.day}`,
            dateRequest: '',
            invalidUser: false,
        };
        this._reportService
            .retrieveReportOffersData(offersParams)
            .pipe(
                take(1),
                tap((result) => {
                    if (result === 0) {
                        this.params.noData = true;
                    } else {
                        this.params.noData = false;
                        this.generated.next(result);
                    }
                }),
                finalize(() => (this.params.pendingData = false)),
            )
            .subscribe();
    }
}
